export default __webpack_public_path__ + "images/dbcc954d3ba6b1c45aa6db3d58007f15-dsrp_tablet.webp";